import React, { useState, useEffect, useRef } from 'react';
import { Tabs, Table, Button, Form, Input, Spin, Space, Select } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, HomeOutlined, SearchOutlined, RedoOutlined, PlusCircleOutlined, EditOutlined, DeleteOutlined, EyeOutlined, CopyOutlined } from '@ant-design/icons';
import Message from '../../component/message/message'; // 提示信息弹窗  
import PopupFrame from '../../component/popupFrame/popupFrame';
import Audit from '../../component/audit/audit';//审核彈框
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import trans from './translation';
import moment from 'moment';//日期格式化导包
import './surveyTemplate.css';

const { TabPane } = Tabs;
const { Option } = Select;
const SurveyTemplate = (props) => {
    const messageRef = useRef();
    const [form] = Form.useForm();
    const [tabIndex, setTabIndex] = useState("1");
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [checkboxState, setCheckboxState] = useState([]);
    const [flag, setFlag] = useState("add");
    const [isAudit, setIsAudit] = useState(false);
    const [isDeleteFrame, setIsDeleteFrame] = useState(false);
    const [tables, setTables] = useState([]);
    const [tablesCount, setTablesCount] = useState(0);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [searchModel, setSearchModel] = useState({});
    const [oldSearchModel, setOldSearchModel] = useState({});
    const [auditModel, setAuditModel] = useState({});
    const [isLoad, setIsLoad] = useState(false);
    const [spinInfo, setSpinInfo] = useState("");
    const [isLeave, setIsLeave] = useState(false);
    const [cohortList, setCohortList] = useState([]);
    const [deleteTipText, setDeleteTipText] = useState("");

    useEffect(() => {
        searchCohortList()
        search(pageSize, 1, "N");
    }, []);

    const searchCohortList = () => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        Base.callBackApi("cohortProg/searchCohortList").then((data) => {
            if ("SUCCESS" === data.msg) {
                let list = data.object ?? []
                setCohortList(list)
            } else {
                errFrameShow("error", data.msg);
            }
        })
    }

    const search = (pageSizeNew, currentPageNew, flag, isShowMsg) => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        messageShowHandler();  // 清除提示信息
        let model = {};
        if ("Y" === flag) {     // 翻页
            model = oldSearchModel;
        } else {
            model = searchModel;
        }
        model.page = currentPageNew;
        model.startRow = (currentPageNew - 1) * pageSizeNew;
        model.pageSize = pageSizeNew;
        setIsLoad(true);
        setSpinInfo(trans.beQuerying[Config.backLang]);
        Base.callBackApi("surveyTemplate/search", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                if (!data?.object?.list && isShowMsg) {
                    errFrameShow("info", trans.noneDate[Config.backLang]);
                }
                if ("N" === flag) {
                    setOldSearchModel(JSON.parse(JSON.stringify(model)));
                }
                setTablesCount(data?.object?.total ?? 0);
                setTables(data?.object?.list ?? []);
                setCurrent(currentPageNew);
                setPageSize(pageSizeNew);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));

    }

    const searchChange = (key, value) => {
        messageShowHandler();
        setSearchModel(model => {
            return { ...model, ...{ [key]: value } };
        });
    }

    const reset = () => {
        messageShowHandler();
        clearSelect();
        setSearchModel({});
        setOldSearchModel({});
        setTablesCount(0);
        setTables([]);
        setPageSize(10);
    }

    // Tab页切换
    const handleSelect = (key) => {
        if (key) {
            if (key === "2") {
                if (checkboxState.length === 1 && Config.funcInfo.canUpdate === "Y") {
                    edit();
                } else if (Config.funcInfo.canInsert === "Y") {
                    add();
                }
            } else if (tabIndex !== "1") {
                setTabIndex("1");
                search(pageSize, current, "Y");
            }
        }
    }

    const add = () => {
        messageShowHandler();
        initForm({});
        setFlag("add");
        setTabIndex("2");
    }

    const update = (model, e) => {
        messageShowHandler();
        searchById(model.surveyTemplateId);
        setFlag("edit");
        setTabIndex("2");
    }

    const edit = () => {
    }

    const initForm = (model = {}) => {
        form.resetFields();
        form.setFieldsValue({
            cohortId: model.cohortId ?? "",
            description: model.description ?? "",
            sectionAQuestion1: model.sectionAQuestion1 ?? "",
            sectionAQuestion2: model.sectionAQuestion2 ?? "",
            sectionAQuestion3: model.sectionAQuestion3 ?? "",
            sectionAQuestion4: model.sectionAQuestion4 ?? "",
            sectionAQuestion5: model.sectionAQuestion5 ?? "",
            sectionAQuestion6: model.sectionAQuestion6 ?? "",
            sectionAQuestion7: model.sectionAQuestion7 ?? "",
            sectionAQuestion8: model.sectionAQuestion8 ?? "",
            sectionAQuestion9: model.sectionAQuestion9 ?? "",
            sectionAQuestion10: model.sectionAQuestion10 ?? "",
            sectionAQuestion1Sc: model.sectionAQuestion1Sc ?? "",
            sectionAQuestion2Sc: model.sectionAQuestion2Sc ?? "",
            sectionAQuestion3Sc: model.sectionAQuestion3Sc ?? "",
            sectionAQuestion4Sc: model.sectionAQuestion4Sc ?? "",
            sectionAQuestion5Sc: model.sectionAQuestion5Sc ?? "",
            sectionAQuestion6Sc: model.sectionAQuestion6Sc ?? "",
            sectionAQuestion7Sc: model.sectionAQuestion7Sc ?? "",
            sectionAQuestion8Sc: model.sectionAQuestion8Sc ?? "",
            sectionAQuestion9Sc: model.sectionAQuestion9Sc ?? "",
            sectionAQuestion10Sc: model.sectionAQuestion10Sc ?? "",
            sectionAQuestion1Tc: model.sectionAQuestion1Tc ?? "",
            sectionAQuestion2Tc: model.sectionAQuestion2Tc ?? "",
            sectionAQuestion3Tc: model.sectionAQuestion3Tc ?? "",
            sectionAQuestion4Tc: model.sectionAQuestion4Tc ?? "",
            sectionAQuestion5Tc: model.sectionAQuestion5Tc ?? "",
            sectionAQuestion6Tc: model.sectionAQuestion6Tc ?? "",
            sectionAQuestion7Tc: model.sectionAQuestion7Tc ?? "",
            sectionAQuestion8Tc: model.sectionAQuestion8Tc ?? "",
            sectionAQuestion9Tc: model.sectionAQuestion9Tc ?? "",
            sectionAQuestion10Tc: model.sectionAQuestion10Tc ?? "",
            sectionBQuestion1: model.sectionBQuestion1 ?? "",
            sectionBQuestion1Sc: model.sectionBQuestion1Sc ?? "",
            sectionBQuestion1Tc: model.sectionBQuestion1Tc ?? "",
            
            sectionCQuestion1: model.sectionCQuestion1 ?? "",
            sectionCQuestion2: model.sectionCQuestion2 ?? "",
            sectionCQuestion3: model.sectionCQuestion3 ?? "",
            sectionCQuestion4: model.sectionCQuestion4 ?? "",
            sectionCQuestion5: model.sectionCQuestion5 ?? "",
            sectionCQuestion6: model.sectionCQuestion6 ?? "",
            sectionCQuestion7: model.sectionCQuestion7 ?? "",
            sectionCQuestion8: model.sectionCQuestion8 ?? "",
            sectionCQuestion9: model.sectionCQuestion9 ?? "",
            sectionCQuestion10: model.sectionCQuestion10 ?? "",
            sectionCQuestion1Sc: model.sectionCQuestion1Sc ?? "",
            sectionCQuestion2Sc: model.sectionCQuestion2Sc ?? "",
            sectionCQuestion3Sc: model.sectionCQuestion3Sc ?? "",
            sectionCQuestion4Sc: model.sectionCQuestion4Sc ?? "",
            sectionCQuestion5Sc: model.sectionCQuestion5Sc ?? "",
            sectionCQuestion6Sc: model.sectionCQuestion6Sc ?? "",
            sectionCQuestion7Sc: model.sectionCQuestion7Sc ?? "",
            sectionCQuestion8Sc: model.sectionCQuestion8Sc ?? "",
            sectionCQuestion9Sc: model.sectionCQuestion9Sc ?? "",
            sectionCQuestion10Sc: model.sectionCQuestion10Sc ?? "",
            sectionCQuestion1Tc: model.sectionCQuestion1Tc ?? "",
            sectionCQuestion2Tc: model.sectionCQuestion2Tc ?? "",
            sectionCQuestion3Tc: model.sectionCQuestion3Tc ?? "",
            sectionCQuestion4Tc: model.sectionCQuestion4Tc ?? "",
            sectionCQuestion5Tc: model.sectionCQuestion5Tc ?? "",
            sectionCQuestion6Tc: model.sectionCQuestion6Tc ?? "",
            sectionCQuestion7Tc: model.sectionCQuestion7Tc ?? "",
            sectionCQuestion8Tc: model.sectionCQuestion8Tc ?? "",
            sectionCQuestion9Tc: model.sectionCQuestion9Tc ?? "",
            sectionCQuestion10Tc: model.sectionCQuestion10Tc ?? "",
        });
    }

    const deleteFrameClose = (state) => {
        if (state) {
            deleteData();
        }
        clearSelect();
        setIsDeleteFrame(false);
    }

    const deleteData = () => {
        setIsLoad(true);
        setSpinInfo(trans.deleteData[Config.backLang]);
        let deleteModel = checkboxState[0];
        deleteModel.menuFuncId = Config.funcInfo.funcId;
        Base.callBackApi("surveyTemplate/delete", deleteModel).then((data) => {
            if ("SUCCESS" === data.msg) {
                cancel();
                search(pageSize, current, "Y", false);
                errFrameShow("success", trans.deleteSuccess[Config.backLang]);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const audit = (model, e) => {
        messageShowHandler();//清空提示信息
        e.stopPropagation();
        setAuditModel(model);
        setIsAudit(true);
    }

    const auditCancel = () => {
        setIsAudit(false);
    }

    const onFinish = (values) => {
        messageShowHandler();
        if (!values.sectionAQuestion1 && !values.sectionAQuestion2 && !values.sectionAQuestion3 && !values.sectionAQuestion4 && !values.sectionAQuestion5 && !values.sectionAQuestion6 && !values.sectionAQuestion7 && !values.sectionAQuestion8 && !values.sectionAQuestion9 && !values.sectionAQuestion10) {
            errFrameShow('error', 'Fill in at least one question in Section A.');
            return;
        }
        setIsLoad(true);
        setSpinInfo(trans.dataBeSaving[Config.backLang])
        let url = "";
        if (flag === "add") {
            url = "surveyTemplate/insert";
        } else {
            url = "surveyTemplate/update"
            values.surveyTemplateId = selectedRowKeys[0];
            values.lastUpdatedDate = checkboxState[0].lastUpdatedDate;
        }
        values.menuFuncId = Config.funcInfo.funcId;
        Base.callBackApi(url, values).then((data) => {
            if ("SUCCESS" === data.msg) {
                searchById(data.object)
                errFrameShow("success", trans.saveSuccess[Config.backLang]);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => {
            setIsLoad(false);
        });
    }

    const searchById = (surveyTemplateId, flag = true) => {
        setIsLoad(true);
        Base.callBackApi("surveyTemplate/searchById", surveyTemplateId).then((data) => {
            if ("SUCCESS" === data.msg) {
                let model = data.object;
                initForm(model);
                setCheckboxState([model]);
                setSelectedRowKeys([model.surveyTemplateId]);
                if (flag) {
                    setFlag("edit");
                }
            } else {
                this.errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const cancel = () => {
        messageShowHandler();
        clearSelect();
        setTabIndex("1");
        search(pageSize, current, "Y");
    }

    const leaveFrameClose = (state) => {
        if (state) {
            cancel();
        }
        setIsLeave(false);
    }

    const deleteOne = (model, e) => {
        e.stopPropagation();
        setDeleteTipText("Cohort" + ":" + model.cohortYear + "")
        setCheckboxState([model])
        setIsDeleteFrame(true);
    }

    //分页 页码切换变化查询
    const onChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, currentNew, "Y");
    }
    //分页 每页條數变化查询
    const onShowSizeChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, 1, "Y");
    }

    //清空列表选中
    const clearSelect = () => {
        setSelectedRowKeys([]);
        setCheckboxState([]);
    }

    // 生成提示信息
    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    // 清除提示信息
    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }
    
    const questionChange = (value, label1,label2) => {
        if (!value) {
            form.validateFields([label1,label2])
        }
    };

    const validateForm = (values,label) => {
        if(label === "sectionAQuestion1" &&  (form.getFieldValue('sectionAQuestion1Tc') || form.getFieldValue('sectionAQuestion1Sc')) && !values ){
            return Promise.reject('English is required.');
        }
        if(label === "sectionAQuestion1Tc" &&  (form.getFieldValue('sectionAQuestion1') || form.getFieldValue('sectionAQuestion1Sc')) && !values ){
            return Promise.reject('Traditional Chinese is required.');
        }
        if(label === "sectionAQuestion1Sc" &&  (form.getFieldValue('sectionAQuestion1') || form.getFieldValue('sectionAQuestion1Tc')) && !values ){
            return Promise.reject('Simplified Chinese is required.');
        }

        if(label === "sectionAQuestion2" &&  (form.getFieldValue('sectionAQuestion2Tc') || form.getFieldValue('sectionAQuestion2Sc')) && !values ){
            return Promise.reject('English is required.');
        }
        if(label === "sectionAQuestion2Tc" &&  (form.getFieldValue('sectionAQuestion2') || form.getFieldValue('sectionAQuestion2Sc')) && !values ){
            return Promise.reject('Traditional Chinese is required.');
        }
        if(label === "sectionAQuestion2Sc" &&  (form.getFieldValue('sectionAQuestion2') || form.getFieldValue('sectionAQuestion2Tc')) && !values ){
            return Promise.reject('Simplified Chinese is required.');
        }

        if(label === "sectionAQuestion3" &&  (form.getFieldValue('sectionAQuestion3Tc') || form.getFieldValue('sectionAQuestion3Sc')) && !values ){
            return Promise.reject('English is required.');
        }
        if(label === "sectionAQuestion3Tc" &&  (form.getFieldValue('sectionAQuestion3') || form.getFieldValue('sectionAQuestion3Sc')) && !values ){
            return Promise.reject('Traditional Chinese is required.');
        }
        if(label === "sectionAQuestion3Sc" &&  (form.getFieldValue('sectionAQuestion3') || form.getFieldValue('sectionAQuestion3Tc')) && !values ){
            return Promise.reject('Simplified Chinese is required.');
        }

        if(label === "sectionAQuestion4" &&  (form.getFieldValue('sectionAQuestion4Tc') || form.getFieldValue('sectionAQuestion4Sc')) && !values ){
            return Promise.reject('English is required.');
        }
        if(label === "sectionAQuestion4Tc" &&  (form.getFieldValue('sectionAQuestion4') || form.getFieldValue('sectionAQuestion4Sc')) && !values ){
            return Promise.reject('Traditional Chinese is required.');
        }
        if(label === "sectionAQuestion4Sc" &&  (form.getFieldValue('sectionAQuestion4') || form.getFieldValue('sectionAQuestion4Tc')) && !values ){
            return Promise.reject('Simplified Chinese is required.');
        }

        if(label === "sectionAQuestion5" &&  (form.getFieldValue('sectionAQuestion5Tc') || form.getFieldValue('sectionAQuestion5Sc')) && !values ){
            return Promise.reject('English is required.');
        }
        if(label === "sectionAQuestion5Tc" &&  (form.getFieldValue('sectionAQuestion5') || form.getFieldValue('sectionAQuestion5Sc')) && !values ){
            return Promise.reject('Traditional Chinese is required.');
        }
        if(label === "sectionAQuestion5Sc" &&  (form.getFieldValue('sectionAQuestion5') || form.getFieldValue('sectionAQuestion5Tc')) && !values ){
            return Promise.reject('Simplified Chinese is required.');
        }

        if(label === "sectionAQuestion6" &&  (form.getFieldValue('sectionAQuestion6Tc') || form.getFieldValue('sectionAQuestion6Sc')) && !values ){
            return Promise.reject('English is required.');
        }
        if(label === "sectionAQuestion6Tc" &&  (form.getFieldValue('sectionAQuestion6') || form.getFieldValue('sectionAQuestion6Sc')) && !values ){
            return Promise.reject('Traditional Chinese is required.');
        }
        if(label === "sectionAQuestion6Sc" &&  (form.getFieldValue('sectionAQuestion6') || form.getFieldValue('sectionAQuestion6Tc')) && !values ){
            return Promise.reject('Simplified Chinese is required.');
        }

        if(label === "sectionAQuestion7" &&  (form.getFieldValue('sectionAQuestion7Tc') || form.getFieldValue('sectionAQuestion7Sc')) && !values ){
            return Promise.reject('English is required.');
        }
        if(label === "sectionAQuestion7Tc" &&  (form.getFieldValue('sectionAQuestion7') || form.getFieldValue('sectionAQuestion7Sc')) && !values ){
            return Promise.reject('Traditional Chinese is required.');
        }
        if(label === "sectionAQuestion7Sc" &&  (form.getFieldValue('sectionAQuestion7') || form.getFieldValue('sectionAQuestion7Tc')) && !values ){
            return Promise.reject('Simplified Chinese is required.');
        }

        if(label === "sectionAQuestion8" &&  (form.getFieldValue('sectionAQuestion8Tc') || form.getFieldValue('sectionAQuestion8Sc')) && !values ){
            return Promise.reject('English is required.');
        }
        if(label === "sectionAQuestion8Tc" &&  (form.getFieldValue('sectionAQuestion8') || form.getFieldValue('sectionAQuestion8Sc')) && !values ){
            return Promise.reject('Traditional Chinese is required.');
        }
        if(label === "sectionAQuestion8Sc" &&  (form.getFieldValue('sectionAQuestion8') || form.getFieldValue('sectionAQuestion8Tc')) && !values ){
            return Promise.reject('Simplified Chinese is required.');
        }

        if(label === "sectionAQuestion9" &&  (form.getFieldValue('sectionAQuestion9Tc') || form.getFieldValue('sectionAQuestion9Sc')) && !values ){
            return Promise.reject('English is required.');
        }
        if(label === "sectionAQuestion9Tc" &&  (form.getFieldValue('sectionAQuestion9') || form.getFieldValue('sectionAQuestion9Sc')) && !values ){
            return Promise.reject('Traditional Chinese is required.');
        }
        if(label === "sectionAQuestion9Sc" &&  (form.getFieldValue('sectionAQuestion9') || form.getFieldValue('sectionAQuestion9Tc')) && !values ){
            return Promise.reject('Simplified Chinese is required.');
        }

        if(label === "sectionAQuestion10" &&  (form.getFieldValue('sectionAQuestion10Tc') || form.getFieldValue('sectionAQuestion10Sc')) && !values ){
            return Promise.reject('English is required.');
        }
        if(label === "sectionAQuestion10Tc" &&  (form.getFieldValue('sectionAQuestion10') || form.getFieldValue('sectionAQuestion10Sc')) && !values ){
            return Promise.reject('Traditional Chinese is required.');
        }
        if(label === "sectionAQuestion10Sc" &&  (form.getFieldValue('sectionAQuestion10') || form.getFieldValue('sectionAQuestion10Tc')) && !values ){
            return Promise.reject('Simplified Chinese is required.');
        }

        if(label === "sectionBQuestion1" &&  (form.getFieldValue('sectionBQuestion1Tc') || form.getFieldValue('sectionBQuestion1Sc')) && !values ){
            return Promise.reject('English is required.');
        }
        if(label === "sectionBQuestion1Tc" &&  (form.getFieldValue('sectionBQuestion1') || form.getFieldValue('sectionBQuestion1Sc')) && !values ){
            return Promise.reject('Traditional Chinese is required.');
        }
        if(label === "sectionBQuestion1Sc" &&  (form.getFieldValue('sectionBQuestion1') || form.getFieldValue('sectionBQuestion1Tc')) && !values ){
            return Promise.reject('Simplified Chinese is required.');
        }

        if(label === "sectionCQuestion1" &&  (form.getFieldValue('sectionCQuestion1Tc') || form.getFieldValue('sectionCQuestion1Sc')) && !values ){
            return Promise.reject('English is required.');
        }
        if(label === "sectionCQuestion1Tc" &&  (form.getFieldValue('sectionCQuestion1') || form.getFieldValue('sectionCQuestion1Sc')) && !values ){
            return Promise.reject('Traditional Chinese is required.');
        }
        if(label === "sectionCQuestion1Sc" &&  (form.getFieldValue('sectionCQuestion1') || form.getFieldValue('sectionCQuestion1Tc')) && !values ){
            return Promise.reject('Simplified Chinese is required.');
        }

        if(label === "sectionCQuestion2" &&  (form.getFieldValue('sectionCQuestion2Tc') || form.getFieldValue('sectionCQuestion2Sc')) && !values ){
            return Promise.reject('English is required.');
        }
        if(label === "sectionCQuestion2Tc" &&  (form.getFieldValue('sectionCQuestion2') || form.getFieldValue('sectionCQuestion2Sc')) && !values ){
            return Promise.reject('Traditional Chinese is required.');
        }
        if(label === "sectionCQuestion2Sc" &&  (form.getFieldValue('sectionCQuestion2') || form.getFieldValue('sectionCQuestion2Tc')) && !values ){
            return Promise.reject('Simplified Chinese is required.');
        }

        if(label === "sectionCQuestion3" &&  (form.getFieldValue('sectionCQuestion3Tc') || form.getFieldValue('sectionCQuestion3Sc')) && !values ){
            return Promise.reject('English is required.');
        }
        if(label === "sectionCQuestion3Tc" &&  (form.getFieldValue('sectionCQuestion3') || form.getFieldValue('sectionCQuestion3Sc')) && !values ){
            return Promise.reject('Traditional Chinese is required.');
        }
        if(label === "sectionCQuestion3Sc" &&  (form.getFieldValue('sectionCQuestion3') || form.getFieldValue('sectionCQuestion3Tc')) && !values ){
            return Promise.reject('Simplified Chinese is required.');
        }

        if(label === "sectionCQuestion4" &&  (form.getFieldValue('sectionCQuestion4Tc') || form.getFieldValue('sectionCQuestion4Sc')) && !values ){
            return Promise.reject('English is required.');
        }
        if(label === "sectionCQuestion4Tc" &&  (form.getFieldValue('sectionCQuestion4') || form.getFieldValue('sectionCQuestion4Sc')) && !values ){
            return Promise.reject('Traditional Chinese is required.');
        }
        if(label === "sectionCQuestion4Sc" &&  (form.getFieldValue('sectionCQuestion4') || form.getFieldValue('sectionCQuestion4Tc')) && !values ){
            return Promise.reject('Simplified Chinese is required.');
        }

        if(label === "sectionCQuestion5" &&  (form.getFieldValue('sectionCQuestion5Tc') || form.getFieldValue('sectionCQuestion5Sc')) && !values ){
            return Promise.reject('English is required.');
        }
        if(label === "sectionCQuestion5Tc" &&  (form.getFieldValue('sectionCQuestion5') || form.getFieldValue('sectionCQuestion5Sc')) && !values ){
            return Promise.reject('Traditional Chinese is required.');
        }
        if(label === "sectionCQuestion5Sc" &&  (form.getFieldValue('sectionCQuestion5') || form.getFieldValue('sectionCQuestion5Tc')) && !values ){
            return Promise.reject('Simplified Chinese is required.');
        }
        return Promise.resolve();
    };
    
    const duplicate = (model, e) => {
        e.stopPropagation();
        messageShowHandler()
        setFlag("add");
        setTabIndex("2");
        searchById(model.surveyTemplateId, false);
    }

    /*eslint-disable*/
    const columns = [
        {
            title: 'Cohort',
            dataIndex: 'cohortYear',
            className: 'tableWidth30',
        },
        {
            title: 'Description',
            dataIndex: 'description',
            className: 'tableWidth40',
        },
        {
            title: "Last Update Date",
            dataIndex: 'lastUpdatedDate',
            className: 'tableWidth30',
            render: (text) => moment(text).format(Config.dateFormatALL)
        },
        {
            title: trans.controls[Config.backLang],
            dataIndex: '',
            className: ' sysControls',
            fixed: 'right',
            width: 300,
            render: (text, record) => <div className='operation'>
                <div className='sysUpdate' onClick={(e) => duplicate(record, e)} hidden={Config.funcInfo.canInsert === "N"}><CopyOutlined /> Duplicate</div>
                <div className='sysUpdate' onClick={(e) => update(record, e)} hidden={Config.funcInfo.canUpdate === "N"}><EditOutlined /> {trans.update[Config.backLang]}</div>
                <div className='sysDelete' onClick={(e) => deleteOne(record, e)} hidden={Config.funcInfo.canDelete === "N"}><DeleteOutlined /> {trans.delete[Config.backLang]}</div>
                <div className='sysLogs' onClick={(e) => audit(record, e)}><EyeOutlined /> {trans.audit[Config.backLang]}</div>
            </div>
        },
    ];

    return (
        <div id="container" className="template surveyTemplate">
            <div className='breadcrumb'>
                <HomeOutlined /> / Admin / <span className='breadcrumbTitle'>{Config.funcInfo['funcName' + (Config.backLang === 'TC' ? 'Tc' : '')]}</span>
            </div>
            {/* 提示信息弹框 */}
            <Message ref={messageRef} />
            <div className='templateMain'>
                <Spin size="large" spinning={isLoad} tip={spinInfo}>
                    {/* 删除弹框 */}
                    {isDeleteFrame ? <PopupFrame close={deleteFrameClose} deleteTipText={deleteTipText} /> : null}
                    {isLeave ? <PopupFrame close={leaveFrameClose} type='leave' /> : null}
                    {/* 审核彈框 */}
                    <Audit visible={isAudit} auditModel={auditModel} close={auditCancel} />
                    <Tabs activeKey={tabIndex} onChange={(e) => handleSelect(e)}>
                        <TabPane key="1" tab={trans.list[Config.backLang]}>
                            <div className='sysSearchRow sysSearchBox'>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysTitle surveyTemplateSerchTitle">{trans.cohortYear[Config.backLang]}</div>
                                        <div className="sysSerchInput">
                                            <Select className="sysSelect" placeholder={trans.cohortYear[Config.backLang]}
                                                value={searchModel.cohortId || ''}
                                                onChange={(e) => searchChange('cohortId', e)}
                                            >
                                                <Option value=''></Option>
                                                {cohortList.map((item) => <Option key={item.cohortId} value={item.cohortId}>{item.cohortYear}</Option>)}
                                            </Select>
                                        </div>
                                    </div>
                                    <div className='sysSearchButton'>
                                        <Button className="sysBtn btnBlue" type="primary" onClick={() => search(pageSize, 1, "N", true)} hidden={Config.funcInfo.canSelect === "N"} icon={<SearchOutlined />}>{trans.search[Config.backLang]}</Button>
                                        <Button className="sysBtn" onClick={reset} icon={<RedoOutlined />}>{trans.reset[Config.backLang]}</Button>
                                    </div>
                                </div>
                            </div>
                            <div className="sysLineEight"></div>
                            <Space size={[5, 5]} wrap className="sysButtonRelative">
                                <Button type="primary" className="sysBtn btnBlue" onClick={add} hidden={Config.funcInfo.canInsert === "N"} icon={<PlusCircleOutlined />}>{trans.add[Config.backLang]}</Button>
                            </Space>
                            <div className="sysTable" id="tableOne">
                                <Table
                                    scroll={{ x: 600 }}
                                    rowKey="surveyTemplateId" //Key值
                                    columns={columns} //列名
                                    dataSource={tables} //数据
                                    pagination={{  //分页
                                        showSizeChanger: true,                //是否显示可以设置几条一页的选项
                                        onChange: onChange,                  //上页下页或者跳页方法
                                        onShowSizeChange: onShowSizeChange,          //每页显示条数方法
                                        total: tablesCount,        //总共多少条数据
                                        current: current,       //当前页
                                        pageSize: pageSize,  //每页显示多少条数据
                                        defaultCurrent: 1,          //默认当前页为1
                                        size: "small"
                                    }}
                                />
                            </div>
                        </TabPane>
                        <TabPane key="2" tab={trans.generalWpaTemplate[Config.backLang]} forceRender={true}>
                            <Form form={form} onFinish={onFinish}>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput mustFill">Cohort</div>
                                        <div className="sysInput ">
                                            <Form.Item
                                                name="cohortId"
                                                rules={[
                                                    { required: true, message: trans.cohortYearNoIsNull[Config.backLang] },
                                                ]}
                                            >
                                                <Select className="sysSelect" placeholder={trans.cohortYear[Config.backLang]} disabled={flag === 'view'}>
                                                    <Option value=''></Option>
                                                    {cohortList.map((item) => <Option key={item.cohortId} value={item.cohortId}>{item.cohortYear}</Option>)}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput mustFill">Description</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="description"
                                                rules={[
                                                    {
                                                        required: true, message: 'Description is required.'
                                                    },
                                                ]}
                                            >
                                                <Input type="text" maxLength={150} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='surveyTemplateSetupBox'>
                                    <h4 className='surveyTemplateSetupBlueBoxTitle'>Section A</h4>
                                    <div className='sysRow'>
                                        <div className='sysColMax'>
                                            <div className="sysParam">Question 1 (English)</div>
                                            <div className="sysInputs">
                                                <Form.Item
                                                    name="sectionAQuestion1"
                                                    rules={[
                                                        {
                                                            validator: (rule, value) => validateForm(value,"sectionAQuestion1")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" maxLength={150} onChange={(e) => questionChange(e.target.value, "sectionAQuestion1Tc","sectionAQuestion1Sc")} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysColMax'>
                                            <div className="sysParam">(Traditional Chinese)</div>
                                            <div className="sysInputs">
                                                <Form.Item
                                                    name="sectionAQuestion1Tc"
                                                    rules={[
                                                        {
                                                            validator: (rule, value) => validateForm(value,"sectionAQuestion1Tc")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" maxLength={150} onChange={(e) => questionChange(e.target.value, "sectionAQuestion1","sectionAQuestion1Sc")} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysColMax'>
                                            <div className="sysParam">(Simplified Chinese)</div>
                                            <div className="sysInputs">
                                                <Form.Item
                                                    name="sectionAQuestion1Sc"
                                                    rules={[
                                                        {
                                                            validator: (rule, value) => validateForm(value,"sectionAQuestion1Sc")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" maxLength={150} onChange={(e) => questionChange(e.target.value, "sectionAQuestion1Tc","sectionAQuestion1")} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysColMax'>
                                            <div className="sysParam">Question 2 (English)</div>
                                            <div className="sysInputs">
                                                <Form.Item
                                                    name="sectionAQuestion2"
                                                    rules={[
                                                        {
                                                            validator: (rule, value) => validateForm(value,"sectionAQuestion2")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" maxLength={150} onChange={(e) => questionChange(e.target.value, "sectionAQuestion2Tc","sectionAQuestion2Sc")} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysColMax'>
                                            <div className="sysParam">(Traditional Chinese)</div>
                                            <div className="sysInputs">
                                                <Form.Item
                                                    name="sectionAQuestion2Tc"
                                                    rules={[
                                                        {
                                                            validator: (rule, value) => validateForm(value,"sectionAQuestion2Tc")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" maxLength={150} onChange={(e) => questionChange(e.target.value, "sectionAQuestion2","sectionAQuestion2Sc")} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysColMax'>
                                            <div className="sysParam">(Simplified Chinese)</div>
                                            <div className="sysInputs">
                                                <Form.Item
                                                    name="sectionAQuestion2Sc"
                                                    rules={[
                                                        {
                                                            validator: (rule, value) => validateForm(value,"sectionAQuestion2Sc")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" maxLength={150} onChange={(e) => questionChange(e.target.value, "sectionAQuestion2Tc","sectionAQuestion2")} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysColMax'>
                                            <div className="sysParam">Question 3 (English)</div>
                                            <div className="sysInputs">
                                                <Form.Item
                                                    name="sectionAQuestion3"
                                                    rules={[
                                                        {
                                                            validator: (rule, value) => validateForm(value,"sectionAQuestion3")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" maxLength={150} onChange={(e) => questionChange(e.target.value, "sectionAQuestion3Tc","sectionAQuestion3Sc")} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysColMax'>
                                            <div className="sysParam">(Traditional Chinese)</div>
                                            <div className="sysInputs">
                                                <Form.Item
                                                    name="sectionAQuestion3Tc"
                                                    rules={[
                                                        {
                                                            validator: (rule, value) => validateForm(value,"sectionAQuestion3Tc")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" maxLength={150} onChange={(e) => questionChange(e.target.value, "sectionAQuestion3","sectionAQuestion3Sc")} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysColMax'>
                                            <div className="sysParam">(Simplified Chinese)</div>
                                            <div className="sysInputs">
                                                <Form.Item
                                                    name="sectionAQuestion3Sc"
                                                    rules={[
                                                        {
                                                            validator: (rule, value) => validateForm(value,"sectionAQuestion3Sc")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" maxLength={150} onChange={(e) => questionChange(e.target.value, "sectionAQuestion3Tc","sectionAQuestion3")} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysColMax'>
                                            <div className="sysParam">Question 4 (English)</div>
                                            <div className="sysInputs">
                                                <Form.Item
                                                    name="sectionAQuestion4"
                                                    rules={[
                                                        {
                                                            validator: (rule, value) => validateForm(value,"sectionAQuestion4")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" maxLength={150} onChange={(e) => questionChange(e.target.value, "sectionAQuestion4Tc","sectionAQuestion4Sc")} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysColMax'>
                                            <div className="sysParam">(Traditional Chinese)</div>
                                            <div className="sysInputs">
                                                <Form.Item
                                                    name="sectionAQuestion4Tc"
                                                    rules={[
                                                        {
                                                            validator: (rule, value) => validateForm(value,"sectionAQuestion4Tc")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" maxLength={150} onChange={(e) => questionChange(e.target.value, "sectionAQuestion4","sectionAQuestion4Sc")} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysColMax'>
                                            <div className="sysParam">(Simplified Chinese)</div>
                                            <div className="sysInputs">
                                                <Form.Item
                                                    name="sectionAQuestion4Sc"
                                                    rules={[
                                                        {
                                                            validator: (rule, value) => validateForm(value,"sectionAQuestion4Sc")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" maxLength={150} onChange={(e) => questionChange(e.target.value, "sectionAQuestion4Tc","sectionAQuestion4")} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysColMax'>
                                            <div className="sysParam">Question 5 (English)</div>
                                            <div className="sysInputs">
                                                <Form.Item
                                                    name="sectionAQuestion5"
                                                    rules={[
                                                        {
                                                            validator: (rule, value) => validateForm(value,"sectionAQuestion5")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" maxLength={150} onChange={(e) => questionChange(e.target.value, "sectionAQuestion5Tc","sectionAQuestion5Sc")} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysColMax'>
                                            <div className="sysParam">(Traditional Chinese)</div>
                                            <div className="sysInputs">
                                                <Form.Item
                                                    name="sectionAQuestion5Tc"
                                                    rules={[
                                                        {
                                                            validator: (rule, value) => validateForm(value,"sectionAQuestion5Tc")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" maxLength={150} onChange={(e) => questionChange(e.target.value, "sectionAQuestion5","sectionAQuestion5Sc")} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysColMax'>
                                            <div className="sysParam">(Simplified Chinese)</div>
                                            <div className="sysInputs">
                                                <Form.Item
                                                    name="sectionAQuestion5Sc"
                                                    rules={[
                                                        {
                                                            validator: (rule, value) => validateForm(value,"sectionAQuestion5Sc")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" maxLength={150} onChange={(e) => questionChange(e.target.value, "sectionAQuestion5Tc","sectionAQuestion5")} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysColMax'>
                                            <div className="sysParam">Question 6 (English)</div>
                                            <div className="sysInputs">
                                                <Form.Item
                                                    name="sectionAQuestion6"
                                                    rules={[
                                                        {
                                                            validator: (rule, value) => validateForm(value,"sectionAQuestion6")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" maxLength={150} onChange={(e) => questionChange(e.target.value, "sectionAQuestion6Tc","sectionAQuestion6Sc")} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysColMax'>
                                            <div className="sysParam">(Traditional Chinese)</div>
                                            <div className="sysInputs">
                                                <Form.Item
                                                    name="sectionAQuestion6Tc"
                                                    rules={[
                                                        {
                                                            validator: (rule, value) => validateForm(value,"sectionAQuestion6Tc")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" maxLength={150} onChange={(e) => questionChange(e.target.value, "sectionAQuestion6","sectionAQuestion6Sc")} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysColMax'>
                                            <div className="sysParam">(Simplified Chinese)</div>
                                            <div className="sysInputs">
                                                <Form.Item
                                                    name="sectionAQuestion6Sc"
                                                    rules={[
                                                        {
                                                            validator: (rule, value) => validateForm(value,"sectionAQuestion6Sc")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" maxLength={150} onChange={(e) => questionChange(e.target.value, "sectionAQuestion6Tc","sectionAQuestion6")} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysColMax'>
                                            <div className="sysParam">Question 7 (English)</div>
                                            <div className="sysInputs">
                                                <Form.Item
                                                    name="sectionAQuestion7"
                                                    rules={[
                                                        {
                                                            validator: (rule, value) => validateForm(value,"sectionAQuestion7")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" maxLength={150} onChange={(e) => questionChange(e.target.value, "sectionAQuestion7Tc","sectionAQuestion7Sc")} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysColMax'>
                                            <div className="sysParam">(Traditional Chinese)</div>
                                            <div className="sysInputs">
                                                <Form.Item
                                                    name="sectionAQuestion7Tc"
                                                    rules={[
                                                        {
                                                            validator: (rule, value) => validateForm(value,"sectionAQuestion7Tc")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" maxLength={150} onChange={(e) => questionChange(e.target.value, "sectionAQuestion7","sectionAQuestion7Sc")} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysColMax'>
                                            <div className="sysParam">(Simplified Chinese)</div>
                                            <div className="sysInputs">
                                                <Form.Item
                                                    name="sectionAQuestion7Sc"
                                                    rules={[
                                                        {
                                                            validator: (rule, value) => validateForm(value,"sectionAQuestion7Sc")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" maxLength={150} onChange={(e) => questionChange(e.target.value, "sectionAQuestion7Tc","sectionAQuestion7")} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysColMax'>
                                            <div className="sysParam">Question 8 (English)</div>
                                            <div className="sysInputs">
                                                <Form.Item
                                                    name="sectionAQuestion8"
                                                    rules={[
                                                        {
                                                            validator: (rule, value) => validateForm(value,"sectionAQuestion8")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" maxLength={150} onChange={(e) => questionChange(e.target.value, "sectionAQuestion8Tc","sectionAQuestion8Sc")} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysColMax'>
                                            <div className="sysParam">(Traditional Chinese)</div>
                                            <div className="sysInputs">
                                                <Form.Item
                                                    name="sectionAQuestion8Tc"
                                                    rules={[
                                                        {
                                                            validator: (rule, value) => validateForm(value,"sectionAQuestion8Tc")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" maxLength={150} onChange={(e) => questionChange(e.target.value, "sectionAQuestion8","sectionAQuestion8Sc")} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysColMax'>
                                            <div className="sysParam">(Simplified Chinese)</div>
                                            <div className="sysInputs">
                                                <Form.Item
                                                    name="sectionAQuestion8Sc"
                                                    rules={[
                                                        {
                                                            validator: (rule, value) => validateForm(value,"sectionAQuestion8Sc")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" maxLength={150} onChange={(e) => questionChange(e.target.value, "sectionAQuestion8Tc","sectionAQuestion8")} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysColMax'>
                                            <div className="sysParam">Question 9 (English)</div>
                                            <div className="sysInputs">
                                                <Form.Item
                                                    name="sectionAQuestion9"
                                                    rules={[
                                                        {
                                                            validator: (rule, value) => validateForm(value,"sectionAQuestion9")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" maxLength={150} onChange={(e) => questionChange(e.target.value, "sectionAQuestion9Tc","sectionAQuestion9Sc")} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysColMax'>
                                            <div className="sysParam">(Traditional Chinese)</div>
                                            <div className="sysInputs">
                                                <Form.Item
                                                    name="sectionAQuestion9Tc"
                                                    rules={[
                                                        {
                                                            validator: (rule, value) => validateForm(value,"sectionAQuestion9Tc")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" maxLength={150} onChange={(e) => questionChange(e.target.value, "sectionAQuestion9","sectionAQuestion9Sc")} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysColMax'>
                                            <div className="sysParam">(Simplified Chinese)</div>
                                            <div className="sysInputs">
                                                <Form.Item
                                                    name="sectionAQuestion9Sc"
                                                    rules={[
                                                        {
                                                            validator: (rule, value) => validateForm(value,"sectionAQuestion9Sc")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" maxLength={150} onChange={(e) => questionChange(e.target.value, "sectionAQuestion9Tc","sectionAQuestion9")} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysColMax'>
                                            <div className="sysParam">Question 10 (English)</div>
                                            <div className="sysInputs">
                                                <Form.Item
                                                    name="sectionAQuestion10"
                                                    rules={[
                                                        {
                                                            validator: (rule, value) => validateForm(value,"sectionAQuestion10")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" maxLength={150} onChange={(e) => questionChange(e.target.value, "sectionAQuestion10Tc","sectionAQuestion10Sc")} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysColMax'>
                                            <div className="sysParam">(Traditional Chinese)</div>
                                            <div className="sysInputs">
                                                <Form.Item
                                                    name="sectionAQuestion10Tc"
                                                    rules={[
                                                        {
                                                            validator: (rule, value) => validateForm(value,"sectionAQuestion10Tc")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" maxLength={150} onChange={(e) => questionChange(e.target.value, "sectionAQuestion10","sectionAQuestion10Sc")} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysColMax'>
                                            <div className="sysParam">(Simplified Chinese)</div>
                                            <div className="sysInputs">
                                                <Form.Item
                                                    name="sectionAQuestion10Sc"
                                                    rules={[
                                                        {
                                                            validator: (rule, value) => validateForm(value,"sectionAQuestion10Sc")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" maxLength={150} onChange={(e) => questionChange(e.target.value, "sectionAQuestion10Tc","sectionAQuestion10")} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='surveyTemplateSetupBox'>
                                    <h4 className='surveyTemplateSetupBlueBoxTitle'>Section B</h4>
                                    <div className='sysRow'>
                                        <div className='sysColMax'>
                                            <div className="sysParam mustFill">Question 1 (English)</div>
                                            <div className="sysInputs">
                                                <Form.Item
                                                    name="sectionBQuestion1"
                                                    rules={[
                                                        {
                                                            required: true, message: 'English is required.'
                                                        },
                                                        {
                                                            validator: (rule, value) => validateForm(value,"sectionBQuestion1")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" maxLength={150} onChange={(e) => questionChange(e.target.value, "sectionBQuestion1Tc","sectionBQuestion1Sc")} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysColMax'>
                                            <div className="sysParam mustFill">(Traditional Chinese)</div>
                                            <div className="sysInputs">
                                                <Form.Item
                                                    name="sectionBQuestion1Tc"
                                                    rules={[
                                                        {
                                                            validator: (rule, value) => validateForm(value,"sectionBQuestion1Tc")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" maxLength={150} onChange={(e) => questionChange(e.target.value, "sectionBQuestion1","sectionBQuestion1Sc")} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysColMax'>
                                            <div className="sysParam mustFill">(Simplified Chinese)</div>
                                            <div className="sysInputs">
                                                <Form.Item
                                                    name="sectionBQuestion1Sc"
                                                    rules={[
                                                        {
                                                            validator: (rule, value) => validateForm(value,"sectionBQuestion1Sc")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" maxLength={150} onChange={(e) => questionChange(e.target.value, "sectionBQuestion1Tc","sectionBQuestion1")} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='surveyTemplateSetupBox'>
                                    <h4 className='surveyTemplateSetupBlueBoxTitle'>Section C</h4>
                                    <div className='sysRow'>
                                        <div className='sysColMax'>
                                            <div className="sysParam">Question 1 (English)</div>
                                            <div className="sysInputs">
                                                <Form.Item
                                                    name="sectionCQuestion1"
                                                    rules={[
                                                        {
                                                            validator: (rule, value) => validateForm(value,"sectionCQuestion1")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" maxLength={150} onChange={(e) => questionChange(e.target.value, "sectionCQuestion1Tc","sectionCQuestion1Sc")} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysColMax'>
                                            <div className="sysParam">(Traditional Chinese)</div>
                                            <div className="sysInputs">
                                                <Form.Item
                                                    name="sectionCQuestion1Tc"
                                                    rules={[
                                                        {
                                                            validator: (rule, value) => validateForm(value,"sectionCQuestion1Tc")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" maxLength={150} onChange={(e) => questionChange(e.target.value, "sectionCQuestion1","sectionCQuestion1Sc")} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysColMax'>
                                            <div className="sysParam">(Simplified Chinese)</div>
                                            <div className="sysInputs">
                                                <Form.Item
                                                    name="sectionCQuestion1Sc"
                                                    rules={[
                                                        {
                                                            validator: (rule, value) => validateForm(value,"sectionCQuestion1Sc")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" maxLength={150} onChange={(e) => questionChange(e.target.value, "sectionCQuestion1Tc","sectionCQuestion1")} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysColMax'>
                                            <div className="sysParam">Question 2 (English)</div>
                                            <div className="sysInputs">
                                                <Form.Item
                                                    name="sectionCQuestion2"
                                                    rules={[
                                                        {
                                                            validator: (rule, value) => validateForm(value,"sectionCQuestion2")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" maxLength={150} onChange={(e) => questionChange(e.target.value, "sectionCQuestion2Tc","sectionCQuestion2Sc")} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysColMax'>
                                            <div className="sysParam">(Traditional Chinese)</div>
                                            <div className="sysInputs">
                                                <Form.Item
                                                    name="sectionCQuestion2Tc"
                                                    rules={[
                                                        {
                                                            validator: (rule, value) => validateForm(value,"sectionCQuestion2Tc")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" maxLength={150} onChange={(e) => questionChange(e.target.value, "sectionCQuestion2","sectionCQuestion2Sc")} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysColMax'>
                                            <div className="sysParam">(Simplified Chinese)</div>
                                            <div className="sysInputs">
                                                <Form.Item
                                                    name="sectionCQuestion2Sc"
                                                    rules={[
                                                        {
                                                            validator: (rule, value) => validateForm(value,"sectionCQuestion2Sc")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" maxLength={150} onChange={(e) => questionChange(e.target.value, "sectionCQuestion2Tc","sectionCQuestion2")} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysColMax'>
                                            <div className="sysParam">Question 3 (English)</div>
                                            <div className="sysInputs">
                                                <Form.Item
                                                    name="sectionCQuestion3"
                                                    rules={[
                                                        {
                                                            validator: (rule, value) => validateForm(value,"sectionCQuestion3")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" maxLength={150} onChange={(e) => questionChange(e.target.value, "sectionCQuestion3Tc","sectionCQuestion3Sc")} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysColMax'>
                                            <div className="sysParam">(Traditional Chinese)</div>
                                            <div className="sysInputs">
                                                <Form.Item
                                                    name="sectionCQuestion3Tc"
                                                    rules={[
                                                        {
                                                            validator: (rule, value) => validateForm(value,"sectionCQuestion3Tc")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" maxLength={150} onChange={(e) => questionChange(e.target.value, "sectionCQuestion3","sectionCQuestion3Sc")} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysColMax'>
                                            <div className="sysParam">(Simplified Chinese)</div>
                                            <div className="sysInputs">
                                                <Form.Item
                                                    name="sectionCQuestion3Sc"
                                                    rules={[
                                                        {
                                                            validator: (rule, value) => validateForm(value,"sectionCQuestion3Sc")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" maxLength={150} onChange={(e) => questionChange(e.target.value, "sectionCQuestion3Tc","sectionCQuestion3")} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysColMax'>
                                            <div className="sysParam">Question 4 (English)</div>
                                            <div className="sysInputs">
                                                <Form.Item
                                                    name="sectionCQuestion4"
                                                    rules={[
                                                        {
                                                            validator: (rule, value) => validateForm(value,"sectionCQuestion4")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" maxLength={150} onChange={(e) => questionChange(e.target.value, "sectionCQuestion4Tc","sectionCQuestion4Sc")} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysColMax'>
                                            <div className="sysParam">(Traditional Chinese)</div>
                                            <div className="sysInputs">
                                                <Form.Item
                                                    name="sectionCQuestion4Tc"
                                                    rules={[
                                                        {
                                                            validator: (rule, value) => validateForm(value,"sectionCQuestion4Tc")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" maxLength={150} onChange={(e) => questionChange(e.target.value, "sectionCQuestion4","sectionCQuestion4Sc")} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysColMax'>
                                            <div className="sysParam">(Simplified Chinese)</div>
                                            <div className="sysInputs">
                                                <Form.Item
                                                    name="sectionCQuestion4Sc"
                                                    rules={[
                                                        {
                                                            validator: (rule, value) => validateForm(value,"sectionCQuestion4Sc")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" maxLength={150} onChange={(e) => questionChange(e.target.value, "sectionCQuestion4Tc","sectionCQuestion4")} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysColMax'>
                                            <div className="sysParam">Question 5 (English)</div>
                                            <div className="sysInputs">
                                                <Form.Item
                                                    name="sectionCQuestion5"
                                                    rules={[
                                                        {
                                                            validator: (rule, value) => validateForm(value,"sectionCQuestion5")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" maxLength={150} onChange={(e) => questionChange(e.target.value, "sectionCQuestion5Tc","sectionCQuestion5Sc")} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysColMax'>
                                            <div className="sysParam">(Traditional Chinese)</div>
                                            <div className="sysInputs">
                                                <Form.Item
                                                    name="sectionCQuestion5Tc"
                                                    rules={[
                                                        {
                                                            validator: (rule, value) => validateForm(value,"sectionCQuestion5Tc")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" maxLength={150} onChange={(e) => questionChange(e.target.value, "sectionCQuestion5","sectionCQuestion5Sc")} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysColMax'>
                                            <div className="sysParam">(Simplified Chinese)</div>
                                            <div className="sysInputs">
                                                <Form.Item
                                                    name="sectionCQuestion5Sc"
                                                    rules={[
                                                        {
                                                            validator: (rule, value) => validateForm(value,"sectionCQuestion5Sc")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" maxLength={150} onChange={(e) => questionChange(e.target.value, "sectionCQuestion5Tc","sectionCQuestion5")} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="sysSaveButton">
                                    <Button className="sysBtn btnBlue" type="primary" disabled={isLoad} icon={<CheckCircleOutlined />} htmlType="submit">{trans.save[Config.backLang]}</Button>
                                    <Button className="sysBtn" icon={<CloseCircleOutlined />} onClick={cancel}>{trans.cancel[Config.backLang]}</Button>
                                </div>
                            </Form>
                        </TabPane>


                    </Tabs>
                </Spin>
            </div>
        </div>
    )

}

export default SurveyTemplate;